import { csv } from "d3"
import { useState, useEffect } from "react"
import rawData from './DRC/events.csv'


const useData = (subType) => {
    const [data, setData] = useState();
    useEffect(() => {
      const row = (d) => {
        d.latitude = +d.latitude;
        d.longitude = +d.longitude
        d.latlng = [+d.latitude,+d.longitude]
        return d;
      };
      csv(rawData, row).then(trimmedData => {
        console.log(trimmedData)
        if (subType != null) {
          trimmedData = trimmedData.filter(item => item.event_type === subType)
        }
        const reducer = trimmedData.reduce((acc, { latlng, event_type }) => {
          if (latlng in acc) {
            acc[latlng] += 1; //iterate for repeated location
          } else {
            acc[latlng] = 1; //instantiate for first instance of a location
          }
          return acc; //object of key:value pairs as {'latlng': count} (where latlng is stringified array)
        }, {});
        //convert to {latlng: 'latlng', eventCount: count} format
        const reducedData = Object.entries(reducer).map(([latlng, eventCount]) => ({
          latlng,
          eventCount,
        }));
        //turn 'latlng' string back to array of integers
        reducedData.map((d) => {
          d.latlng = d.latlng.split(",").map((e) => +e);
          d.eventCount = +d.eventCount;
          return d
        });
        setData(reducedData)});
    }, [subType]);
    console.log(data)

    return data;
}


export default useData